<div
  class="w-100 py-1 h-100 d-flex justify-content-center justify-content-lg-start align-items-center"
>
 <div
   style="max-width: 250px"
   class="w-100 bg-neutral-color-f d-flex align-items-center px-2 rounded-pill"
 >
   <div class="flex-grow-1 d-flex justify-content-start align-items-center">
     <span
       class="material-symbols-outlined text-title text-neutral-color-e me-3 pointer hover:text-complementary-color-a"
       (click)="unselectAll()"
     >
       close_small
     </span>
     <span class="text-mini py-1 pe-2">
       {{selectedProcessResults.length}} {{ language?.selectedItems || 'Selected' | titlecase }}
     </span>
   </div>
   <div class="d-flex justify-content-end align-items-center">
     <div
       *ngIf="loadingBulkRemoveProcessResult"
       class="spinner-grow spinner-grow-sm text-complementary-color-a me-sm-1" role="status"
     ></div>

     <span
       *ngIf="!loadingBulkRemoveProcessResult && deletePermissions"
       class="material-symbols-outlined text-sub-title hover:text-complementary-color-a pointer user-select-none"
       tooltip="{{language?.delete || 'delete' | titlecase}}"
       container="body"
       containerClass="text-mini fw-bold mb-1"
       (click)="remove($event, this.selectedProcessResults)"
     >
       delete
     </span>
   </div>


 </div>

</div>
